<style>
@import "../account.scss";
</style>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'ConsumerLogout',
  data () {
    return { }
  },
  computed: {
    ...mapGetters(['consumerInfo'])
  }
}
</script>

<template>
  <div
    id="consumer-logout"
    class="py-5"
  >
    <div
      class="mt-6"
    >
      <div class="src-user-icon my-5">
        <i class="fa fa-user-circle-o text-primary fa-5x" />
      </div>
      <div
        id="logged-in-page"
        class="row mt-3 justify-content-center"
      >
        <h3 class="col-md-12 text-center text-lg font-weight-bold">
          {{ $t ('label.myAccount') }}
        </h3>
        <small
          id="email-account-value"
          class="col-md-12 text-center mt-3 mb-5 text-muted"
        >
          {{ consumerInfo.email }}
        </small>
      </div>
    </div>
  </div>
</template>
